module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/star3.0a0ec00e.png";